import React from 'react';
import { Link } from 'react-router-dom';

function MobileMenu({ isOpen, onClose }) {
    const handleHomeClick = (event) => {
        onClose();

        if (typeof window === 'undefined') return;
        if (window.location.pathname !== '/') return;

        event.preventDefault();
        const hero = document.getElementById('banner');
        if (hero) {
            hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
    };

    return (
        <div className={`th-menu-wrapper onepage-nav ${isOpen ? "th-body-visible" : ""}`}
            style={{ visibility: isOpen ? "visible" : "hidden" }}>

            <div className="th-menu-area text-center">
                <button className="th-menu-toggle" onClick={onClose} aria-label="Close">
                    <i className="fal fa-times" />
                </button>

                <div className="mobile-logo">
                    <Link to="/" onClick={onClose}>
                        <img src="/assets/img/logo3.png" alt="Urumavahini" />
                    </Link>
                </div>

                <div className="th-mobile-menu">
                    <ul>
                        <li><Link to="/" onClick={handleHomeClick}>Home</Link></li>
                        <li><Link to="/#about" onClick={onClose}>About Us</Link></li>
                        <li><Link to="/travel-with-dinesh" onClick={onClose}>Travel with dinesh</Link></li>
                        <li><Link to="/ape-pansala" onClick={onClose}>Ape pansala</Link></li>
                        <li><Link to="/urumaya" onClick={onClose}>Urumaya</Link></li>
                        <li><Link to="/ranga-rata" onClick={onClose}>Ranga Rata</Link></li>
                        <li><Link to="/#contact" onClick={onClose}>Contact us</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;
